
function SdInputUsersController($q, UserSettingService) {
    var ctrl = this;

    //ctrl.allUsers = [
    //    { UserID: 'jamesm@seed.com.br', text: 'jamesm'},
    //    { UserID: 'jamesmaul@gmail.com', text: 'jamesmaul'}
    //];

    this.$onInit = function () {        
    };

    ctrl.searchUsers = function (query) {
        return UserSettingService.getUsersQuery(query)
            .then(function (response) {
                var resp = response.data.map(function (item) {
                    return {
                        UserID: item.Key,
                        text: item.Key, //componente obriga
                    };
                });
                console.log('search', resp);
                return resp;
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    //ctrl.loadUsers = function (query) {
    //    var deferred = $q.defer();                
    //    var items = ctrl.allUsers.filter(function (c) {
    //        if (c.UserID.toUpperCase().includes(query.toUpperCase())) {
    //            return c;
    //        }
    //    });
    //    //console.log('loadUsers', items);
    //    deferred.resolve(items);
    //    return deferred.promise;
    //};

}

seedWebApp.component('sdInputUsers', {
    controller: SdInputUsersController,
    controllerAs: 'ctrl',
    bindings: {        
        name: '@',
        options: '<',           // Modelo (Key, Value)
        label: '<',             // Label do input
        ngModel: '=',             // Modelo à ser alterado
    },
    templateUrl: './SPA/components/sd-input-users.html'
});